import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

class MainWrapper extends PureComponent {
    render() {
        let wrapperClass = classNames({
            'blocks-with-shadow-theme': this.props.customizer.withBoxShadow,
            'squared-corner-theme': this.props.customizer.squaredCorners,
            'top-navigation': this.props.customizer.topNavigation,
            'wrapper': true,
            'wrapper--full-width': this.props.sidebar.collapse
        });

        const theme = this.props.theme.className;
        return (
            <div className={theme}>
                <div className={wrapperClass}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default connect(state => {
    return {
        customizer: state.customizer,
        sidebar: state.sidebar,
        theme: state.theme
    }
})(MainWrapper);


// WEBPACK FOOTER //
// ./src/theme/app/MainWrapper.js